

import {
  FETCH_TAX_REQUEST,
  FETCH_TAX_SUCCESS,
  FETCH_TAX_FAILURE,
  CREATE_TAX_REQUEST,
  CREATE_TAX_SUCCESS,
  CREATE_TAX_FAILURE,
  UPDATE_TAX_REQUEST,
  UPDATE_TAX_SUCCESS,
  UPDATE_TAX_FAILURE,
} from "./taxsettingActionType";

const initialState = {
  TaxData: [],
  loading: false,
  error: null,
};

const taxsettingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        TaxData: action.payload.data,
      };
    case FETCH_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        TaxData: [],
      };

    case CREATE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CREATE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        TaxData: action.payload.data,
        error: null,
      };
    case CREATE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_TAX_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UPDATE_TAX_SUCCESS:
      return {
        ...state,
        loading: false,
        TaxData: action.payload.data,
        error: null,
      };
    case UPDATE_TAX_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default taxsettingReducer;
